import { useEffect } from 'react';
import { Box, Container, Grid, Paper } from '@mui/material';
import { Controller, FieldErrors, FieldValues, useForm } from 'react-hook-form';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';

import CustomButton from '../../../components/Button/button';
import CustomTextField from '../../../components/TextField/textField';
import CustomTypography from '../../../components/Typography/typography';
import styles from '../../../assets/styles/forgotpassword';
import {
  authSliceActions,
  forgotpassword,
} from '../../../redux/slice/authSlice';
import logo from '../../../assets/images/logo1.png';

const ForgotPassword = () => {
  const classes = styles();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const forgotpasswordData = useSelector(
    (state: any) => state.auth.forgotpasswordData
  );
  const form = useForm({
    defaultValues: {
      email: '',
    },
  });
  const { handleSubmit, formState, control, clearErrors, reset } = form;
  const { errors, isSubmitting, isSubmitted } = formState;

  //submit method that calls forgot password api
  const onSubmit = (data: FieldValues) => {
    const newData = { ...data, email: data.email.toLowerCase() };
    dispatch(forgotpassword(newData));
  };

  const onError = (errors: FieldErrors) => {};

  useEffect(() => {
    if (isSubmitted === true) {
      forgotpasswordData !== null && forgotpasswordData?.success
        ? toast.success(forgotpasswordData?.message)
        : toast.error(forgotpasswordData?.message);
    }
    if (forgotpasswordData !== null && forgotpasswordData?.success) {
      reset({ email: '' });
      navigate('/');
      dispatch(authSliceActions.clearForgotPasswordData());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [forgotpasswordData]);

  return (
    <>
      <Container maxWidth='sm' className={classes.containerRoot}>
        <Box className={classes.Box}>
          <Paper className={classes.headingText} elevation={5}>
            <div className='heading-container'>
              <div>
                <CustomTypography variant='h3'>
                  Forgot Password
                </CustomTypography>
              </div>
              <img alt='logo' src={logo} width={80} className='logo-image' />
            </div>

            <form onSubmit={handleSubmit(onSubmit, onError)}>
              <Grid container className={classes.GridContainer} spacing={1}>
                <Grid item xs={12} sm={12}>
                  <Controller
                    name='email'
                    control={control}
                    render={({ field }) => (
                      <CustomTextField
                        {...field}
                        label='Email'
                        fullWidth
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                          field.onChange(e.target.value, clearErrors('root'));
                        }}
                      />
                    )}
                    rules={{
                      required: {
                        value: true,
                        message: 'Please enter a email',
                      },
                      pattern: {
                        value: /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g,
                        message: 'Please enter valid Email',
                      },
                      validate: {
                        whitespace: (fieldValue: string) => {
                          return (
                            /^[ \t]+/.test(fieldValue) !== true ||
                            "Email can't be whitespace"
                          );
                        },
                      },
                    }}
                  />
                  <CustomTypography
                    variant='body2'
                    color={'red'}
                    align='justify'
                  >
                    {errors.email?.message?.toString()}
                  </CustomTypography>
                </Grid>

                <CustomButton
                  type='submit'
                  fullWidth
                  color='primary'
                  disabled={isSubmitting}
                >
                  {' '}
                  Send Reset Link
                </CustomButton>
              </Grid>
            </form>

            <CustomTypography align='right' className={classes.GridContainer}>
              <Link
                // underline="always"
                to='/'
                className='customAuthLinkStyle'
              >
                <CustomButton variant='text' color='primary'>
                  {'Back to Sign in'}
                </CustomButton>
              </Link>
            </CustomTypography>
          </Paper>
        </Box>
      </Container>
    </>
  );
};

export default ForgotPassword;
